import React, { useEffect, useState } from "react";
import { fetchCmsContent } from "../services/fetchCmsContent";
import MainPageComponents from "../components/CommonComponents/MainPageComponents";

interface AboutItem {
  title: string;
  slug: string;
  content: string;
}

const AboutPage: React.FC = () => {
  const [about, setAbout] = useState<AboutItem | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchCmsContent("About Us", "/api/cms/about-us", setAbout, setLoading);
  }, []);


  return (
    <MainPageComponents
      title={about?.title || "About Us"}
      content={about?.content || ""}
      loading={loading}
      updated_at=""
    />);
};

export default AboutPage;
